var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mr2-gantt-chart-container" },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [_vm._v(_vm._s(_vm.currentSeconds))]
      ),
      _vm.$truckLoading
        ? [_c("div", { staticClass: "loader-round" })]
        : _c(
            "div",
            { staticClass: "scroll-bar-wrap", style: _vm.gcContainerStyle },
            [
              _vm.filteredTrucks.length >= 1
                ? _c(
                    "div",
                    {
                      ref: "ganttChart",
                      staticClass: "gantt-chart scroll-box",
                      attrs: { id: "ganttChart" },
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "gantt-chart-header",
                          style: _vm.gcHeaderStyle,
                          attrs: { type: "flex" },
                        },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "left",
                              style: {
                                width: _vm.$isMobile
                                  ? _vm.smallLeftWidth + "px"
                                  : _vm.leftWidth + "px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "header cursor-pointer",
                                  staticStyle: { width: "60px" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSort("driverName")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("general.driver")) + " "
                                  ),
                                  _vm.isSortAsc.driverName === null
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "sort" },
                                      })
                                    : _vm.isSortAsc.driverName
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "sort-up" },
                                      })
                                    : _c("font-awesome-icon", {
                                        attrs: { icon: "sort-down" },
                                      }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "header cursor-pointer",
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSort("plateNumber")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("general.carPlate")) +
                                      " "
                                  ),
                                  _vm.isSortAsc.plateNumber === null
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "sort" },
                                      })
                                    : _vm.isSortAsc.plateNumber
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "sort-up" },
                                      })
                                    : _c("font-awesome-icon", {
                                        attrs: { icon: "sort-down" },
                                      }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "header cursor-pointer",
                                  staticStyle: { width: "120px" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSort("projectCode")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("planning.route")) + " "
                                  ),
                                  _vm.isSortAsc.projectCode === null
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "sort" },
                                      })
                                    : _vm.isSortAsc.projectCode
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "sort-up" },
                                      })
                                    : _c("font-awesome-icon", {
                                        attrs: { icon: "sort-down" },
                                      }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "header mini" }, [
                                _vm._v(_vm._s(_vm.$t("planning.map"))),
                              ]),
                              _c("div", { staticClass: "header" }, [
                                _vm._v(_vm._s(_vm.$t("navigation.schedule"))),
                              ]),
                            ]
                          ),
                          _c(
                            "el-col",
                            { staticClass: "right" },
                            _vm._l(_vm.timeList, function (date, dateIndex) {
                              return _c(
                                "div",
                                {
                                  key: dateIndex,
                                  staticClass: "time-list-container",
                                },
                                [
                                  date.date ===
                                  new Date().toISOString().split("T")[0]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "time-list-date text-center",
                                          style: {
                                            left:
                                              _vm.currentTimeLeft -
                                              34 * 5 -
                                              13 +
                                              "px",
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(date.date) + " ")]
                                      )
                                    : _vm._e(),
                                  _vm._l(
                                    date.hourList,
                                    function (hour, hourIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: "h" + hourIndex,
                                          staticClass: "hour-list text-center",
                                          style: {
                                            left: _vm.getHourLeft({
                                              dateIndex: dateIndex,
                                              hourIndex: hourIndex,
                                              hourLength: date.hourList.length,
                                            }),
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(hour) + " ")]
                                      )
                                    }
                                  ),
                                  _vm._l(
                                    date.minuteList,
                                    function (minute, minuteIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: minuteIndex,
                                          staticClass: "time-list",
                                          style: {
                                            left: _vm.getMinuteLeft({
                                              dateIndex: dateIndex,
                                              minuteIndex: minuteIndex,
                                              minuteLength:
                                                date.minuteList.length,
                                            }),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              style: _vm.getMinuteStyle(minute),
                                            },
                                            [_vm._v(_vm._s(minute))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticClass: "vertical-lines-header",
                          style: _vm.gcHeaderStyle,
                          attrs: { type: "flex" },
                        },
                        [
                          _c("el-col", { staticClass: "left" }),
                          _c(
                            "el-col",
                            {
                              staticClass: "right",
                              style: {
                                "margin-left": _vm.$isMobile
                                  ? _vm.smallLeftWidth + "px"
                                  : _vm.leftWidth + "px",
                              },
                            },
                            _vm._l(_vm.timeList, function (date, dateIndex) {
                              return _c(
                                "div",
                                {
                                  key: "t" + dateIndex,
                                  staticClass: "vertical-lines-container",
                                },
                                _vm._l(
                                  date.minuteList,
                                  function (minute, minuteIndex) {
                                    return dateIndex !== 0 || minuteIndex !== 0
                                      ? _c("div", {
                                          key: "t" + minuteIndex,
                                          staticClass: "vertical-lines",
                                          style: {
                                            left: _vm.getMinuteLeft({
                                              dateIndex: dateIndex,
                                              minuteIndex: minuteIndex,
                                              minuteLength:
                                                date.minuteList.length,
                                            }),
                                            height:
                                              _vm.filteredTrucks.length * 80 +
                                              "px",
                                          },
                                        })
                                      : _vm._e()
                                  }
                                ),
                                0
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.filteredTrucks, function (truck, truckIndex) {
                        return _c(
                          "el-row",
                          {
                            key: truckIndex,
                            staticClass: "truck no-gutters",
                            class: _vm.getGCRowClass(truck, truckIndex),
                            style: _vm.getGCRowStyle(truck, truckIndex),
                            attrs: { type: "flex" },
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticClass: "truck-header",
                                style: {
                                  width: _vm.$isMobile
                                    ? _vm.smallLeftWidth + "px"
                                    : _vm.leftWidth + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "index" }, [
                                  _vm._v(_vm._s(truckIndex + 1)),
                                ]),
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("h2", { staticClass: "m-0" }, [
                                          _vm._v(_vm._s(truck.driver.name)),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "title",
                                        staticStyle: {
                                          width: "55px",
                                          "margin-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(truck.driver.name) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("h2", { staticClass: "m-0" }, [
                                          _vm._v(_vm._s(truck.plateNumber)),
                                        ]),
                                      ]
                                    ),
                                    _c("div", { staticClass: "title" }, [
                                      _vm._v(
                                        " " + _vm._s(truck.plateNumber) + " "
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("h2", { staticClass: "m-0" }, [
                                          _vm._v(_vm._s(truck.projectCode[0])),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "title",
                                        staticStyle: { width: "120px" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(truck.projectCode[0]) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "title mini cursor-pointer" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["far", "map"] },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openMap(truck)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "subtitle" }, [
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.$t("planning.planned"))),
                                  ]),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.$t("planning.actual"))),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "truck-timetable",
                                style: {
                                  width: _vm.$isMobile
                                    ? "calc(100% - " +
                                      _vm.smallLeftWidth +
                                      "px)"
                                    : "calc(100% - " + _vm.leftWidth + "px)",
                                },
                              },
                              [
                                _vm.isTodayInRange
                                  ? _c("div", {
                                      staticClass: "current-time",
                                      style: {
                                        left: _vm.currentTimeLeft + "px",
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "content" },
                                  [
                                    _vm._l(
                                      truck.routes,
                                      function (route, routeIndex) {
                                        return _c(
                                          "div",
                                          {
                                            key:
                                              "r-" +
                                              route.masterpointId +
                                              "-" +
                                              routeIndex,
                                            staticClass:
                                              "cursor-pointer position-absolute",
                                            style: _vm.getContainerStyles(
                                              route,
                                              "plannedRoutes"
                                            ),
                                          },
                                          [
                                            route &&
                                            _vm.isDateInRange(
                                              route,
                                              "plannedRoutes"
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor-pointer position-absolute",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "travelling-time",
                                                      style: _vm.getRouteStyles(
                                                        {
                                                          route: route,
                                                          dimensionType:
                                                            "travellingTime",
                                                          routeType:
                                                            "plannedRoutes",
                                                        }
                                                      ),
                                                    }),
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              slot: "content",
                                                            },
                                                            slot: "content",
                                                          },
                                                          [
                                                            _c(
                                                              "h2",
                                                              {
                                                                staticClass:
                                                                  "m-0",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    route.shipmentReference.join(
                                                                      ", "
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "m-0",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.helper
                                                                      .uniq(
                                                                        route.companyName
                                                                      )
                                                                      .join(
                                                                        ", "
                                                                      )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "m-0",
                                                              },
                                                              [
                                                                route.startTime
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.calcStartTime(
                                                                              {
                                                                                route:
                                                                                  route,
                                                                                routeType:
                                                                                  "plannedRoutes",
                                                                                showSeconds: false,
                                                                              }
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                route.endTime
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " - " +
                                                                          _vm._s(
                                                                            route.endTime.substring(
                                                                              11,
                                                                              16
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "handling-time",
                                                            class:
                                                              _vm.getStatusColor(
                                                                route
                                                              ),
                                                            style:
                                                              _vm.getRouteStyles(
                                                                {
                                                                  route: route,
                                                                  dimensionType:
                                                                    "handlingTime",
                                                                  routeType:
                                                                    "plannedRoutes",
                                                                }
                                                              ),
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.helper
                                                                    .uniq(
                                                                      route.companyName
                                                                    )
                                                                    .join(", ")
                                                                )
                                                              ),
                                                            ]),
                                                            _c("div", [
                                                              route.startTime
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.calcStartTime(
                                                                            {
                                                                              route:
                                                                                route,
                                                                              routeType:
                                                                                "plannedRoutes",
                                                                              showSeconds: false,
                                                                            }
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              route.endTime
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " - " +
                                                                        _vm._s(
                                                                          route.endTime.substring(
                                                                            11,
                                                                            16
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      truck.routes,
                                      function (route, routeIndex) {
                                        return _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.routeViewOptions.includes(
                                                    "actualRoutes"
                                                  ),
                                                expression:
                                                  "routeViewOptions.includes('actualRoutes')",
                                              },
                                            ],
                                            key:
                                              "ar-" +
                                              route.masterpointId +
                                              "-" +
                                              routeIndex,
                                            staticClass:
                                              "cursor-pointer position-absolute",
                                            style: _vm.getContainerStyles(
                                              route,
                                              "actualRoutes"
                                            ),
                                          },
                                          [
                                            route.actualData &&
                                            _vm.isDateInRange(
                                              route,
                                              "actualRoutes"
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor-pointer position-absolute",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "a-travelling-time",
                                                      style: _vm.getRouteStyles(
                                                        {
                                                          route: route,
                                                          dimensionType:
                                                            "actualTravellingTime",
                                                          routeType:
                                                            "actualRoutes",
                                                        }
                                                      ),
                                                    }),
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              slot: "content",
                                                            },
                                                            slot: "content",
                                                          },
                                                          [
                                                            _c(
                                                              "h2",
                                                              {
                                                                staticClass:
                                                                  "m-0",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    route.shipmentReference.join(
                                                                      ", "
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "m-0",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.helper
                                                                      .uniq(
                                                                        route.companyName
                                                                      )
                                                                      .join(
                                                                        ", "
                                                                      )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "m-0",
                                                              },
                                                              [
                                                                route.actualData
                                                                  .startTime
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.calcStartTime(
                                                                              {
                                                                                route:
                                                                                  route,
                                                                                routeType:
                                                                                  "actualRoutes",
                                                                                showSeconds: false,
                                                                              }
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                route.actualData
                                                                  .endTime
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " - " +
                                                                          _vm._s(
                                                                            route.actualData.endTime.substring(
                                                                              11,
                                                                              16
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "a-handling-time",
                                                            style:
                                                              _vm.getRouteStyles(
                                                                {
                                                                  route: route,
                                                                  dimensionType:
                                                                    "actualHandlingTime",
                                                                  routeType:
                                                                    "actualRoutes",
                                                                }
                                                              ),
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.helper
                                                                    .uniq(
                                                                      route.companyName
                                                                    )
                                                                    .join(", ")
                                                                )
                                                              ),
                                                            ]),
                                                            _c("div", [
                                                              route.actualData
                                                                .startTime
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.calcStartTime(
                                                                            {
                                                                              route:
                                                                                route,
                                                                              routeType:
                                                                                "actualRoutes",
                                                                              showSeconds: false,
                                                                            }
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              route.actualData
                                                                .endTime
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " - " +
                                                                        _vm._s(
                                                                          route.actualData.endTime.substring(
                                                                            11,
                                                                            16
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c("div", { staticClass: "v-cover-bar" }),
              _c("div", { staticClass: "h-cover-bar" }),
              _vm.filteredTrucks.length === 0
                ? _c("div", [
                    _c("p", { staticClass: "no-vehicle" }, [
                      _vm._v(_vm._s(_vm.$t("general.noData"))),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }